import { BaseUniDriver, UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { ButtonUniDriver } from '../Button/Button.uni.driver';

export interface BaseModalLayoutUniDriver extends BaseUniDriver {
  getTheme(): Promise<string>;
  clickCloseButton(): Promise<void>;
  clickHelpButton(): Promise<void>;
  childExists(dataHook: string): Promise<boolean>;
  getTitleText(): Promise<string>;
  getSubtitleText(): Promise<string>;
  getSecondaryButtonDriver(): Promise<ButtonUniDriver>;
  getPrimaryButtonDriver(): Promise<ButtonUniDriver>;
  getPrimaryButtonTooltipContent(): Promise<string>;
  getIllustrationSrc(): Promise<string>;
}

export declare const baseModalLayoutDriverFactory: (
  base: UniDriver,
) => BaseModalLayoutUniDriver;
